import { Container, cssVar, GenericModal, Header, Label, useAlignments, useSizes } from 'metrix-common3';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import SignaturePad from 'react-signature-canvas';
import styled from 'styled-components';

const SignContainer = styled(Container)`
    border: 1px solid ${cssVar.colorDarkMode};
    border-radius: 4px;
    width: 100%;
`;

//This component needs following functions:
//1. closePad - Close Signature pad
//2. updateProgressBar - Update progress bar as per status after saving signature (optional)
//3. doReduceParameter - Set parameter for API call (refer saga)
//4. doExecutePolicyAction - Set Policy status for API call (refer saga)

const Signature = (props) => {
    const alignments = useAlignments();
    const sizes = useSizes();
    const [error, setError] = useState(false);
    const signPad = React.createRef();
    let clientSign = null;

    return (
        <GenericModal
            animate
            visible
            closeEvent={() => props.closePad()}
            items={
                <React.Fragment>
                    <Header
                        text={<FormattedMessage id='Profile_CommonComponents_Signature.signDocs' />}
                        size={sizes.lg}
                    />
                    <Label
                        text={<FormattedMessage id='Profile_CommonComponents_Signature.instructions' />}
                        bold
                        textAlign={alignments.left}
                        bottom={sizes.md}
                    />
                    {error && (
                        <Label
                            text={<FormattedMessage id='Profile_CommonComponents_Signature.errorMessage' />}
                            color={cssVar.colorError}
                            bold
                            textAlign={alignments.left}
                            bottom={sizes.md}
                        />
                    )}
                    <SignContainer color={cssVar.colorStrokeVeryLight}>
                        <SignaturePad ref={signPad} canvasProps={{ width: 350, height: 150 }} />
                    </SignContainer>
                </React.Fragment>
            }
            actionButtons={[
                {
                    text: <FormattedMessage id='Profile_CommonComponents_Signature.save' />,
                    clickEvent: () => {
                        if (!signPad.current.isEmpty()) {
                            clientSign = signPad.current.toDataURL();
                            props.doReduceParameter({ code: 'Signature', value: clientSign.split(',')[1] });
                            props.doExecutePolicyAction({ code: 'RequestBind' });
                            props.closePad();
                            props.updateProgressBar?.('bound');
                        } else {
                            setError(true);
                        }
                    },
                },
                {
                    text: <FormattedMessage id='Profile_CommonComponents_Signature.clear' />,
                    clickEvent: () => {
                        signPad.current.clear();
                    },
                },
                {
                    text: <FormattedMessage id='Profile_CommonComponents_Signature.cancel' />,
                    clickEvent: () => {
                        props.closePad();
                    },
                },
            ]}
        />
    );
};

export default Signature;
